<template>
    <div>
        <!--新增-->
        <div class="ind_main ind_main2">
            <el-form ref="form" :model="form" label-width="120px" >
                <div class="ind_cont rk_cont">
                    <div class="ruku_top">
                        <div class="ruku_from">
                            <el-col :xs="24" :sm="12" :md="8">
                                <el-form-item  label="工作單號 :" >
                                    <el-input size="medium" v-model="form.sCode" :disabled="form.sCodeShow" style="width: 65%" @blur="selSCode()"></el-input>
                                </el-form-item>
                                <el-form-item  label="姓  名 :">
                                    <span style="color: black;font-size: 16px;">{{form.name}}</span>
                                </el-form-item>
                                <el-form-item  label="銷售員 :" >
                                    <span style="color: black;font-size: 16px;">{{form.sales}}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="8">
                                <el-form-item label="客戶編號 :" >
                                    <template v-if="form.codeShow"><span style="color: black;font-size: 16px;">{{form.code}}</span></template>
                                    <template v-else>
                                        <el-autocomplete style="width: 65%" size="medium" :disabled="form.codeShow" v-on:input="addList(0,0,'cCode')"
                                                         class="inline-input"
                                                         v-model="form.code"
                                                         :fetch-suggestions="querySearch"
                                                         :trigger-on-focus="false"
                                                         @select="handleSelect"
                                        ></el-autocomplete>
                                    </template>
                                </el-form-item>
                                <el-form-item  label="電  話 :" >
                                    <span style="color: black;font-size: 16px;">{{form.phone}}</span>
                                </el-form-item>
                                <el-form-item  label="地  址 :" >
                                    <span style="color: black;font-size: 16px;word-wrap: break-word;word-break: normal;">{{form.address}}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="8">
                                <el-form-item>
                                    <template slot="label">
                                        總體積<span v-if="form.unitVolume">({{form.unitVolume==='1'?'箱':form.unitVolume==='2'?'cu.ft':'m³'}})</span>
                                    </template>
                                    <span style="color: black;font-size: 16px;">{{form.totalVolume}}</span>
                                </el-form-item>
                                <el-form-item  label="單 價 :">
                                    <div style="display: flex;justify-content: space-between;">
                                        <div>
                                            <el-input size="medium" v-model="form.price" style="width: 80px" @input="$forceUpdate()" @blur="handlePrice(form.price)" />
                                        </div>
                                        <div>
                                            <span style="color: #000000">體積單位 :</span>
                                            <el-select v-model="form.unitVolume" size="medium" placeholder="" style="width: 80px" :disabled="oldUnitVolume!=null" @change="$forceUpdate()">
                                                <el-option label="箱" value="1" />
                                                <el-option label="立方尺" value="2" />
                                                <el-option label="立方米" value="3" />
                                            </el-select>                                            
                                        </div>
                                    </div>
                                    <div style="line-height: 20px;font-size: 13px !important">上一次單價 : {{form.prePrice}}<br />入庫單號 : {{form.storInCode}}<br />入庫時間 : {{form.storInTime}}</div>
                                </el-form-item>
                                <el-form-item  label="總價格(HKD) :" >
                                    <span style="color: black;font-size: 16px;">{{formatCurrency(form.totalPrice)}}&nbsp;</span>
                                    <div style="line-height: 20px;font-size: 13px !important;position:relative;top:-10px">
                                        出倉金額(HKD) : {{formatCurrency(form.outTotalAmount)}}<br />
                                        剩餘金額(HKD) : {{formatCurrency(form.remainingAmount)}}
                                    </div>
                                </el-form-item>
                            </el-col>
                            <!-- <el-col :span="12" style="text-align: right"> -->
                                <!--<template v-if="EDIT_STOR_IN">-->
                                <!--<template v-if="!rkCont">-->
                                <!--<el-button type="primary" :disabled="addShow" @click="addWarehousing">新 建</el-button>-->
                                <!--</template>-->
                                <!--</template>-->
                            <!-- </el-col> -->
                        </div>
                    </div>
                </div>

                <div class="ruku_list">
                    <el-form>
                        <table cellspacing="0" cellpadding="0" class="responsive">
                            <template v-for="(items,i) in addWarehousingList" >
                                <thead :key="i">
                                <tr >
                                    <th colspan="7" style="text-align: left">
                                        <el-date-picker v-model="items.createDate" format="yyyy年MM月dd日 HH:mm"
                                                        type="datetime" style="width: 40%" size="large">
                                        </el-date-picker>
                                    </th>
                                    <th colspan="2">
                                        <span>第{{items.second}}次</span>
                                        <template v-if="items.storInItem.length === 0 || items.state === 0">
                                            <el-button icon="el-icon-delete" type="danger" circle @click="delAddWarehousingList(items,i)">刪除</el-button>
                                        </template>
                                    </th>
                                </tr>
                                <tr>
                                    <th width="8%">編號</th>
                                    <th width="9%">位置</th>
                                    <th width="7%">單位</th>
                                    <th>物品</th>
                                    <!-- <th width="15%">規格(長寬高)(cm)</th> -->
                                    <!-- <th width="8%">計算體積</th> -->
                                    <th width="14%">
                                        剩餘體積<span v-if="form.unitVolume">({{form.unitVolume==='1'?'箱':form.unitVolume==='2'?'cu.ft':'m³'}})</span>
                                    </th>
                                    <th width="10%">出倉體積</th>
                                    <th width="7%">出入倉紀錄</th>
                                    <th width="8%">剩餘件數</th>
                                    <th width="10%">出倉件數</th>
                                    <!-- <th width="15%">總額</th> -->
                                </tr>
                                </thead>
                                <tr v-for="(item1,index) in items.storInItem" :key="index">
                                    <td class="number" width="8%">
                                        <template v-if="item1.state ===1">
                                            <span>{{item1.boxNo}}</span>
                                        </template>
                                        <template v-else>
                                            <el-input v-model="item1.boxNo" @change="addList(i,index,'boxNo')" :disabled="item1.boxNoShow" size="medium"
                                                      onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input>
                                        </template>
                                    </td>
                                    <td class="actions" width="9%">
                                        <template v-if="item1.state ===1">
                                            <span>{{item1.value}}</span>
                                        </template>
                                        <template v-else>
                                            <el-select :style="items.addStorIn==false?'float: left;':''"  size="medium" :disabled="item1.locationIdShows"
                                                        v-model="item1.value" default-first-option clearable
                                                        filterable remote reserve-keyword @change="handleSelectState($event,i,index)"
                                                        placeholder=""  @focus="isNullOptions4()"
                                                        :remote-method="remoteMethod"
                                                        :loading="tableloading">
                                                <el-option
                                                        v-for="item in options4"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </template>
                                    </td>
                                    <td width="7%">
                                        <template v-if="item1.state ===1">
                                            <span>{{item1.unit}}</span>
                                        </template>
                                        <template v-else>
                                            <el-select size="medium" v-model="item1.unit" @change="addList(i,index,'unit')" placeholder="請輸入" :disabled="item1.unitShow">
                                                <el-option
                                                        v-for="item in company"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </template>
                                    </td>
                                    <td class="name" style="text-align: left;">
                                        <template v-if="item1.state ===1">
                                            <span>{{item1.item}}</span>
                                        </template>
                                        <template v-else>
                                            <el-autocomplete :disabled="item1.itemShows" size="medium" v-on:input="addList(i,index,'item')" style="width: 100%" class="inline-input"
                                                             v-model="item1.item" :fetch-suggestions="querySearchRemark"
                                                             placeholder="請輸入內容"
                                                             @select="addList(i,index,'item')"
                                            ></el-autocomplete>
                                        </template>
                                    </td>
                                    <!-- <td width="15%">
                                        <template v-if="item1.state ===1">
                                            {{item1.length}} {{item1.wide}} {{item1.high}}
                                        </template>
                                        <template v-else>
                                            <el-input v-model="item1.length" style="width: 30%"  :disabled="item1.ckgShow" maxlength="5" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" @blur="handleArea('length', item1, i)" />
                                            <el-input v-model="item1.wide" style="width: 30%" :disabled="item1.ckgShow" maxlength="5" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" @blur="handleArea('wide', item1, i)" />
                                            <el-input v-model="item1.high" style="width: 30%" :disabled="item1.ckgShow" maxlength="5" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" @blur="handleArea('high', item1, i)" />
                                        </template>
                                    </td> -->
                                    <!-- <td width="8%">
                                        {{item1.countVolume}}
                                    </td> -->
                                    <td width="14%">
                                        <template v-if="item1.state ===1">
                                            {{item1.remainingVolume}} 
                                        </template>
                                        <template v-else>
                                            <el-input size="medium" v-model="item1.remainingVolume" :disabled="item1.ckgShow" @blur="handleBlurVolume(item1, i)"/>
                                        </template>
                                    </td>
                                    <td width="10%">
                                        {{ !item1.deliverVolume ? '' : item1.deliverVolume }}
                                    </td>
                                    <th width="8%">
                                        <el-button size="mini" type="success" circle @click="handleOpenRecord(item1)">查看</el-button>
                                    </th>
                                    <td width="7%">
                                        <template v-if="item1.state ===1">
                                            {{item1.remainingQuantity}}
                                        </template>
                                        <template v-else>
                                            <el-input size="medium" v-model="item1.remainingQuantity" :disabled="item1.ckgShow" maxlength="3" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" v-on:input="addList(i,index,'remainingQuantity')"/>
                                        </template>
                                    </td>
                                    <td width="10%">
                                        {{ !item1.deliverGodown ? '' : item1.deliverGodown }}
                                        <template v-if="item1.state === 0">
                                            <el-button type="danger" size="mini" circle @click="delStorInItem(i,index)">刪除</el-button>
                                        </template>
                                        <!-- <template v-else-if="item1.state === 1">
                                            <span>已出倉</span>
                                        </template> -->
                                    </td>
                                    <!-- <td class="actions" width="15%">
                                        {{ item1.inItemPrice }}
                                        <template v-if="item1.state === 1">
                                            <el-col :span="16"><span>{{item1.qty}}</span></el-col>
                                            <el-col :span="8"><span>已出倉</span></el-col>
                                        </template>
                                        <template v-else>
                                            <el-col :span="16">
                                                <el-input style="width: 100%" v-model="item1.qty" @focus="addList(i,index,'qty')" :disabled="item1.qtyShow"  size="medium"
                                                      onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input>
                                            </el-col>
                                            <el-col :span="8">
                                                <template v-if="item1.state === 0">
                                                    <el-button type="danger" size="small" circle @click="delStorInItem(i,index)">刪除</el-button>
                                                </template>
                                                <template v-else-if="item1.state === 1">
                                                    <span>已出倉</span>
                                                </template>
                                            </el-col>
                                        </template>
                                    </td> -->
                                </tr>
                                <tr>
                                    <td colspan="8"><br/></td>
                                </tr>
                            </template>
                        </table>
                        <div class="rk_btn">
                             <el-button type="primary"  @click="submitStorIn"  icon="el-icon-check" circle>保存</el-button>
                            <el-button v-if="$store.getters.customerInSte == false" type="warning"  @click="retSearch" icon="el-icon-delete" circle> 取消</el-button>
                            <el-button v-if="$store.getters.customerInSte"  type="warning"  @click ="retSearch" icon="el-icon-delete" circle> 返回</el-button>
                        </div>
                    </el-form>
                </div>
            </el-form>
        </div>
        <!-- 查看對話框 -->
        <el-dialog title="" :visible.sync="dialogVisible" width="70%" center :close-on-click-modal=false :show-close=false>
            <el-table :data="recordList" style="width: 100%">
                <el-table-column prop="oldVolume" label="原體積" width="120" />
                <el-table-column prop="updateVolume" label="編輯體積" width="120" />
                <el-table-column prop="oldQuantity" label="原件數" width="120" />
                <el-table-column label="編輯件數" width="120" >
                    <template slot-scope="scope">
                        {{ Math.abs(Number(scope.row.totalQuantity)-Number(scope.row.oldQuantity)) }} 
                    </template>
                </el-table-column>
                <el-table-column prop="totalVolume" label="總體積" width="120"/>
                <el-table-column prop="totalQuantity" label="總件數" width="120" />
                <el-table-column prop="createDate" label="時間">
                    <template slot-scope="scope">
                        {{ formatDate(scope.row.createDate) }} 
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="備注" width="100" />
            </el-table>
            <div style="margin-top: 30px;display:flex;justify-content:center;">
                <el-button size="medium" @click="dialogVisible = false">關閉</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {getStorInList,getCIdList,getPrePrice,getStotInOutRecord,getCustomerCodeList,insertStorIn,selStorInItem,getLocationByState,updateStorIn,getCustomerById,
        getSalesList,getStorInListId,getLocationBycusId,delStorInDate,delStorInItem,getAllRemarkList,selCode,getStaffAllList } from '../api/api'
    export default {
        data() {
            return{
                recordList: [],
                dialogVisible: false,
                options4: [],
                salesList:[],//銷售員LIST
                saList:[],//銷售員LIST
                custSalesList:[],//銷售員LIST
                list: [],
                tableloading:false,
                warehousingList:[],
                storIn:[],//入庫詳細資訊
                customerCode:{},
                remarkList:[],//常用列表
                locationList:{},//架子表信息
                addNum:false,
                updateStorIn:"",
                codeList:[],
                company:[
                    {value:'籠',label:'籠'},
                    {value:'盒',label:'盒'},
                    {value:'板',label:'板'},
                    {value:'散件',label:'散件'},
                ], //單位
                storInId:0,
                typeId:1,
                custId:0,
                addWarehousingList:[
                    {state:1,second:1,createDate:null,code:this.RndNum(),addStorIn:true,storInItem:[{addStorinItem:true,num:1,boxNo:1,item:'',qty:null,locationId:'',value:'',itemShows:true,qtyShow:true,locationIdShows:true}]},
                ],
                show:true,//資訊頁面
                add:false,//添加頁面
                rkCont:null,//入庫和客戶資訊
                submitInfo:true,//是否禁止保存按钮
                code:'',
                pager:{
                    page:0,
                    size:15,
                    total:0
                },
                form:{
                    id:null,
                    sCode:'',
                    code:null,
                    name:null,
                    phone:null,
                    address:null,
                    sales:null,
                    createDate:null,
                    sCodeShow:false,
                    codeShow:false,
                    nameShow:false,
                    phoneShow:false,
                    addressShow:false,
                    salesShow:false,
                    price: null,
                    unitVolume: null,
                    totalPrice: null,
                    totalVolume: null,
                    outTotalAmount: null,
                    remainingAmount: null
                },
                searchStorIn:'',
                searchName:'',
                searchSalesId:'',
                acctStockId:'',
                oldUnitVolume: null
            }
        },
        methods: {
            formatCurrency(amount, decimalPlaces = 2) {
                if(!amount) return
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'decimal',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: decimalPlaces
                });
                return `${formatter.format(amount)}`;
            },
            formatDate(time) {
                if(!time) return
                let date = new Date(time*1000)
                let year = date.getFullYear();
                let month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的，所以要加1，并且需要两位数表示
                let day = date.getDate().toString().padStart(2, '0');
                let hours = date.getHours().toString().padStart(2, '0');
                let minutes = date.getMinutes().toString().padStart(2, '0');
                let seconds = date.getSeconds().toString().padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            },
            handleOpenRecord(item){
                if(!item.id) return
                getStotInOutRecord(item.id).then((res)=>{
                    if(res){
                        this.recordList = res.data.data || []
                        this.dialogVisible = true
                    }
                })
            },
            selSCode(){/*查詢入庫單是否重复*/
                selCode(this.form.sCode).then(data =>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        if(res.data !== null){//数据庫中没有当前入庫單號
                            if(res.data.code !== this.updateStorIn){//当前輸入的帐号是否是修改的帐号
                                this.$alert("當前入庫單號:"+this.form.sCode +" 已存在!", '提示', {
                                    confirmButtonText: '確定',
                                    type: 'warning',
                                    callback: action => {
                                        if(this.updateStorIn!==""){
                                            this.form.sCode=this.updateStorIn;
                                        }else{
                                            this.form.sCode="";
                                        }
                                    }
                                });
                            }
                        }
                    }else{
                        this.$message.error(res.errmsg);
                    }
                })
            },
            retSearch(){	//返回搜索界面
                if(this.typeId==2){
                    this.$router.push({
                        name: '客戶詳情',
                        params:{
                            id:this.custId,
                        }
                    })
                    this.$store.commit("closeTab", 'updateStockin');
                }else{
                    this.$router.push({
                        name: '入倉',
                        params: {str: new Date().getTime()}
                    })
                    this.$store.commit("closeTab", 'updateStockin');
                }
            },
            remoteMethod(query) {/*選擇位置*/
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.options4 = this.list.filter(item => {
                            return item.label.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                        });
                    }, 200);
                } else {
                    this.options4 = [];
                }
            },
            remoteMethodSales(query) {/*選擇銷售員*/
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.saList = this.salesList.filter(item => {
                            return item.label.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                        });
                    }, 200);
                } else {
                    this.options4 = [];
                }
            },
            clickLoad(){/*点击銷售員框时加载*/
                this.saList =[];
                this.saList = this.salesList;
            },
            handleCurrentChange(){
                this.getWarehousing();
            },
            isDate(){/*处理日期*/
                this.addWarehousingList.forEach((a,i) =>{
                    if(a.createDate){
                        a.createDate= Math.round(new Date(a.createDate).getTime()/1000)//new Date(a.createDate*1000).Format("yyyy-MM-dd hh:mm")
                    }
                })
            },
            isStringNull(){/*檢查是否為空*/
                let str="";
                if(this.form.sCode === null || this.form.sCode === "" || this.form.sCode===undefined){
                    return "工作單號不能為空"
                }
                if(this.form.code === null || this.form.code === ""){
                    return "客戶編號不能為空"
                }
                if(this.form.name === null || this.form.name === ""){
                    return "物品不能為空"
                }
                if(this.form.phone === null || this.form.phone === ""){
                    return "電話不能為空"
                }
                if(this.form.address === null || this.form.address === ""){
                    return "位址不能為空"
                }
                if(this.form.sales === null || this.form.sales === ""){
                    return "銷售員不能為空"
                }
                if(this.form.createDate === null || this.form.createDate === ""){
                    return "時間不能為空"
                }
                try {
                    this.addWarehousingList.forEach((a,i) =>{
                        if(a.createDate === null || a.createDate === ""){
                            str = "Job00"+(i + 1)+"的時間不能為空";
                            foreach.break = new Error(str);
                        }else {
                            a.storInItem.forEach((item,j) =>{
                                if(item.item === ""){
                                    a.storInItem.splice(j,1)//刪除當前這條沒有值的資料
                                }else {
                                    let num=0;
                                    if(this.addShow === true){//点击新建后把最前面的变为反的
                                        if(i === 0){
                                            num = this.addWarehousingList.length;
                                        }else{
                                            num = i - 1;
                                        }
                                    }else {
                                        num = i + 1;
                                    }
                                    if(item.unit === null || item.unit === "" || item.unit ===undefined){
                                        str = "第"+ num +"次的單位不能為空";
                                        foreach.break = new Error(str);
                                    }
                                    if(item.boxNo === null || item.boxNo === 0){
                                        str = "第"+ num +"次的編號不能為空";
                                        foreach.break = new Error(str);
                                    }
                                    if(item.item === null || item.item === ""){
                                        str = "第"+ num +"次的名稱不能為空";
                                        foreach.break = new Error(str);
                                    }
                                    // if(item.qty === null || item.qty === ""){
                                    //     str = "第"+ num +"次的數量不能為空";
                                    //     foreach.break = new Error(str);
                                    // }
                                    // if(item.quantity === null || item.quantity === ""){
                                    //     str = "第"+ num +"次的件數不能為空";
                                    //     foreach.break = new Error(str);
                                    // }
                                    if((!item.remainingQuantity || item.remainingQuantity==0 || item.remainingQuantity ==null) && item.state!=1){
                                        str = "無出倉件數，第"+ num +"次的剩餘件數必須大於0";
                                        foreach.break = new Error(str);
                                    }
                                    if(item.locationId === null || item.locationId === ""){
                                        str = "位置不能為空";
                                        foreach.break = new Error(str);
                                    }
                                    // item.qty = Number(item.qty);
                                    item.qty = 1
                                    item.remainingQuantity = Number(item.remainingQuantity)
                                    item.quantity = Number(item.remainingQuantity) + Number(item.deliverGodown || 0)
                                    item.remainingVolume = Number(item.remainingVolume)
                                    item.volume = Number(item.remainingVolume) + Number(item.deliverVolume || 0)
                                    
                                    if(!item.addStorinItem && (item.remainingVolume!=item.oldRemainingVolume || item.remainingQuantity != item.oldRemainingQuantity)) {
                                        item.updateStorinItem = true
                                    }
                                }
                            });
                        }
                        let nary =this.addWarehousingList[i].storInItem.sort();//查找是否有重复的單位和BOX
                        var obj={};
                        var obj1={};
                        for(var j=0,l=nary.length;j<l;j++){
                            if(nary[j].state === 0){
                                if(obj[nary[j].boxNo+","+nary[j].unit]){
                                    if(obj1[nary[j].unit]){
                                        str = "有重複的單位: "+nary[j].unit+" ,和編號: "+nary[j].boxNo;
                                        foreach.break = new Error(str);
                                    }
                                }else{
                                    obj[nary[j].boxNo+","+nary[j].unit]=nary[j].boxNo+","+nary[j].unit;
                                    obj1[nary[j].unit]=nary[j].unit;
                                }
                            }
                        }
                    });
                }catch (e){
                    return str;
                }
                return str;
            },
            getWarehousing(){/*查詢入庫*/
                this.submitInfo=true;
                this.tableloading=true;
                let params={page:this.pager.page,size:this.pager.size,storIn:this.searchStorIn.trim(),custName:this.searchName.trim(),salesId:this.searchSalesId};
                return getStorInList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        let {size,page,total,data:items=[]}=res.data;
                        this.warehousingList=items;
                        this.warehousingList.forEach((a,b)=>{
                            a.storInDate = new Date(a.storInDate*1000).Format("yyyy-MM-dd hh:mm");
                            this.$set(this.warehousingList[b],'value',a.customer.code);//向陣列裡添加value欄位
                        });
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.tableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            addWarehousing(){/*點擊新增後向陣列添加一條資料*/
                this.addShow = true;
                let boxNo;
                this.addWarehousingList.forEach((item,i)=>{//查詢当前BOXNO 最大值 +1
                    let index = Number(this.addWarehousingList.length - 1);
                    let a = Number(this.addWarehousingList[index].storInItem.length -1);
                    boxNo= Number(this.addWarehousingList[index].storInItem[a].boxNo)+1;
                });
                this.addWarehousingList.unshift({state:0,second:this.addWarehousingList.length+1,createDate:new Date().Format("yyyy-MM-dd hh:mm:ss"),code:null,addStorIn:true,
                    storInItem:[{state:0,unitShow:true,num:1,addStorinItem:true,boxNo:boxNo,item:'',qty:null,locationId:'',value:'',boxNoShow:false,itemShows:true,qtyShow:true,locationIdShows:false, length: null,wide:null,high:null,ckgShow:true,volume:null,remainingVolume: null,oldRemainingVolume:null,countVolume:null,deliverGodown: null,deliverVolume:null,inItemPrice: 0,remainingQuantity: null,oldRemainingQuantity:null,updateStorinItem:false,quantity:null,quantityShow:true}]});
            },
            querySearch(queryString, cb) {/*載入數據*/
                var restaurants =this.customerCode;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 調用 callback 返回建議清單的資料
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {/*選擇客編號後*/
                getCustomerById(item.id).then(data =>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        //console.log("resCUS",res);
                        let {id,code,name,phone,address,sales}=res.data[0];
                        this.form.id = id;
                        this.form.code =code;
                        this.form.name =name;
                        this.form.address =address;
                        this.form.phone =phone;
                        this.form.sales =sales;
                        if(id != undefined){
                            this.getLocationByCusId(id);
                        }
                    }else{
                        this.$message.error(res.errmsg);
                    }
                })
            },
            querySearchRemark(queryString, cb) {/*載入常用列表數據*/
                var restaurants =this.remarkList;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 調用 callback 返回建議清單的資料
                cb(results);
            },
            selCustimerId(id){/*查詢客戶ID*/
                getStorInListId(id).then(data =>{
                    let {data:res={}}=data;
                    //console.log(res)
                    if(res.errcode===200){
                        let {id,code,name,phone,address}=res.data.customer;
                        this.form.id = id;
                        this.form.code =code;
                        this.form.name =name;
                        this.form.address =address;
                        this.form.phone =phone;
                        this.form.sales =res.data.sales;
                        this.form.sCode =res.data.scode;
                        this.form.price =res.data.price;
                        this.form.totalPrice =res.data.totalPrice;
                        this.form.totalVolume =res.data.totalVolume;
                        this.form.outTotalAmount =res.data.outTotalAmount;
                        this.form.remainingAmount =res.data.remainingAmount;
                        this.form.unitVolume =res.data.unitVolume;
                        this.form.prePrice = res.data.lastPrice
                        this.form.storInCode = res.data.lastCode
                        this.form.storInTime = res.data.lastStorInTime
                        this.oldUnitVolume = this.form.unitVolume
                        if(id != undefined) {
                            this.getLocationByCusId(id);
                            // getPrePrice({custId: id, code: res.data.scode}).then((result)=>{
                            //     if(result) {
                            //         const { price,code:storInCode,storInTime } = result.data.data
                            //         this.form.prePrice = price
                            //         this.form.storInCode = storInCode
                            //         this.form.storInTime = storInTime
                            //         this.$forceUpdate()
                            //     }
                            // }).catch(()=>{})
                        }
                    }
                })
            },
            delAddWarehousingList(item,i){/*删除StorInDate表中数据*/
                this.$confirm('此操作將永久刪除該數據, 是否繼續?', '提示', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if(this.addShow === true){
                        this.addWarehousingList.splice(i, 1);//删除数组
                        this.addShow = false;
                    }else{
                        return delStorInDate(item.id).then(str=> {//删除
                            let {data: res = {}} = str;
                            let mes="";
                            if (res.errcode === 200) {
                                this.addWarehousingList.splice(i, 1);//删除数组
                                mes="刪除成功"
                            }else{
                                mes="刪除失敗"
                            }
                            this.$message({
                                type: 'info',
                                message: mes
                            });
                        });
                    }
                    //let id = this.addWarehousingList[i].id;
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消刪除'
                    });
                });
            },
            delStorInItem(i,index){/*删除StorInItem表中数据*/
                this.$confirm('此操作將永久刪除該數據, 是否繼續?', '提示', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (this.addWarehousingList[i].storInItem[index].addStorinItem === true) {
                        this.addWarehousingList[i].storInItem.splice(index, 1);//删除数据
                    } else {
                        let id = this.addWarehousingList[i].storInItem[index].id;
                        return delStorInItem(id).then(str => {//删除
                            let {data: res = {}} = str;
                            let mes = "";
                            if (res.errcode === 200) {
                                this.addWarehousingList[i].storInItem.splice(index, 1);//删除数据
                                mes = "刪除成功"
                            } else {
                                mes = "刪除失敗"
                            }
                            this.$message({
                                type: 'info',
                                message: mes
                            });
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消刪除'
                            });
                        })
                    }
                })
                //console.log("l",this.addWarehousingList[i].storInItem[index])
            },
            handleSelectState(id,i,index) {/*選擇位置後 向陣列添加一條新資料*/
                this.addWarehousingList[i].storInItem[index].unitShow=false;
                this.addWarehousingList[i].storInItem[index].locationId=id;//向選擇位置後的資訊添加位置ID
                return
                if(this.addWarehousingList[i].storInItem[index].num === 1){//
                    let box = Number(this.addWarehousingList[i].storInItem[index].boxNo);
                    this.addWarehousingList[i].storInItem.push({state:0,unitShow:true,unit:'',num:1,addStorinItem:true,boxNo:box+1,item:'',qty:null,locationId:'',value:'',itemShows:false,qtyShow:true,locationIdShows:false});
                }
                this.addWarehousingList[i].storInItem[index].num = 0;
                this.addWarehousingList[i].storInItem[index+1].unit = this.addWarehousingList[i].storInItem[index].unit;
                this.addWarehousingList[i].storInItem[index].locationId=id;//向選擇位置後的資訊添加位置ID
            },
            isNullOptions4(){/*点击时清空当前数组*/
                this.options4 = [];
                //this.getLocationByCusId(this.form.id);
            },
            selSotrIn(id,typeId,custId){/*查詢入庫的詳細資訊*/
                this.$store.commit("setSearchSte",false);
                this.$store.commit("setCustomerInSte",false);
                this.selLocationState();//查詢架子
                this.add = true;
                this.show = false;
                this.addShow=false;
                this.rkCont = false;//入庫和客戶資訊
                this.storInId= id;
                this.typeId=typeId;
                this.custId=custId;
                let params={page:this.pager.page,size:100,storInId:id};
                return selStorInItem(params).then(str=>{//查詢當前入庫單裡有多少資料
                    let {data:res={}}=str;
                    //console.log("res",res);
                    if(res.errcode===200){
                        let leagueMap= new Map();
                        let cId;
                        let i=1;
                        res.data.data.forEach((item)=>{//重新處理下資料
                            this.form.createDate = new Date(item.createDate * 1000).Format("yyyy-MM-dd hh:mm");
                            let itemList={};cId=item.cId;this.updateStorIn = item.sCode;
                            let floor;
                            if(item.floor === 0){ floor= "GF "+item.name; }else { floor=item.floor+"F "+item.name; }
                            if(item.state === 1){//是否是當天時間 不是當天的時間不能修改
                                itemList= {unitShow:true,unit:item.unit,num:0,addStorinItem:false,id:item.id,boxNo:item.boxNo,item:item.item,qty:item.qty,locationId:item.locationId,value:floor,state:item.state,
                                    itemShows:true,qtyShow:true,locationIdShows:true,boxNoShow:true,length: item.length,wide:item.wide,high:item.high,ckgShow:true,volume:item.volume,remainingVolume: item.remainingVolume,oldRemainingVolume:item.remainingVolume,countVolume:item.countVolume,deliverGodown:item.deliverGodown,deliverVolume:item.deliverVolume,inItemPrice:item.inItemPrice,remainingQuantity:item.remainingQuantity,oldRemainingQuantity:item.remainingQuantity,updateStorinItem:false,quantity:item.quantity,quantityShow:true};
                            }else{
                                itemList= {unitShow:false,unit:item.unit,num:0,addStorinItem:false,id:item.id,boxNo:item.boxNo,item:item.item,qty:item.qty,locationId:item.locationId,value:floor,state:item.state,
                                    itemShow:false,qtyShow:false,locationIdShow:false,length: item.length,wide:item.wide,high:item.high,ckgShow:false,volume:item.volume,remainingVolume: item.remainingVolume,oldRemainingVolume:item.remainingVolume,countVolume:item.countVolume,deliverGodown:item.deliverGodown,deliverVolume:item.deliverVolume,inItemPrice:item.inItemPrice,remainingQuantity:item.remainingQuantity,oldRemainingQuantity:item.remainingQuantity,updateStorinItem:false,quantity:item.quantity,quantityShow:false};
                            }
                            if(!leagueMap.has(item.storDateId)){//添加
                                let storIdItemList={state:1,second:i,id:item.storDateId,code:item.sCode,createDate:new Date(item.createDate * 1000).Format("yyyy-MM-dd hh:mm:ss"),
                                    addStorIn:false,storInItem:[itemList]};
                                leagueMap.set(item.storDateId,storIdItemList);
                                i++;
                            }else{
                                leagueMap.get(item.storDateId).storInItem.push(itemList)
                            }
                        });
                        this.addWarehousingList =[... leagueMap.values()];
                        let boxNo;
                        this.addWarehousingList.forEach((item,i) =>{//查詢当前BOX 最大值 +1
                            let index = Number(this.addWarehousingList.length - 1);
                            let a = Number(this.addWarehousingList[index].storInItem.length -1);
                            boxNo= Number(this.addWarehousingList[index].storInItem.length);
                            item.storInItem.push({state:0,unitShow:true,unit:'',num:1,addStorinItem:true,id:item.id,boxNo:boxNo+1,item:'',qty:null,locationId:'',value:'',
                                itemShows:true,qtyShow:true,locationIdShows:false,length: null,wide:null,high:null,ckgShow:true,volume:null,remainingVolume:null,oldRemainingVolume:null,countVolume:null,deliverGodown:null,deliverVolume:null,inItemPrice:0,remainingQuantity:null,oldRemainingQuantity:null,updateStorinItem:false,quantity:null,quantityShow:true})
                        });
                        this.selCustimerId(id);//查詢客戶id
                        this.form.codeShow = true;
                        this.form.sCodeShow = false;
                        this.form.nameShow = true;
                        this.form.phoneShow = true;
                        this.form.addressShow = true;
                        this.form.salesShow = true;
                    }
                });

            },
            submitStorIn(){/*保存資料到資料庫*/
                this.submitInfo =false;//禁止保存按钮
                let str = this.isStringNull();
                let params={
                    code:this.form.sCode,
                    storInId:this.storInId,
                    totalVolume: Number(this.form.totalVolume),
                    price: Number(this.form.price),
                    totalPrice:this.form.totalPrice,
                    unitVolume:this.form.unitVolume,
                    customers:{
                        id:this.form.id,
                        code:this.form.code,
                        name:this.form.name,
                        address:this.form.address,
                        phone:this.form.phone,
                        sales:this.form.sales,
                        createDate:Math.round((new Date(this.form.createDate)).getTime()/1000),
                    },storInDateList:this.addWarehousingList};
                //console.log("pa",params); WHETHER_PUBLIC 当前架子是否公共使用(0不公用 1公用)
                if(str !== ""){
                    this.submitInfo = true;
                    this.$alert(str, '提示', {
                        confirmButtonText: '確定',
                        type: 'error',
                        callback: action => {
                            let boxNo;
                            this.addWarehousingList.forEach((item,i) =>{//查詢当前BOX 最大值 +1
                                let index = Number(this.addWarehousingList.length - 1);
                                let a = Number(this.addWarehousingList[index].storInItem.length -1);
                                boxNo= Number(this.addWarehousingList[index].storInItem[a].boxNo)+1;
                                //console.log(item.storInItem[a]);
                                if(item.storInItem[a].quantity !== null || item.storInItem[a].locationId !== ""){
                                    item.storInItem.push({state:0,unitShow:true,unit:'',num:0,addStorinItem:true,id:item.id,boxNo:boxNo+i,item:'',qty:null,locationId:'',value:'',
                                        itemShows:true,qtyShow:true,locationIdShows:false,length: null,wide:null,high:null,ckgShow:true,volume:null,remainingVolume:null,oldRemainingVolume:null,countVolume:null,deliverGodown:null,deliverVolume:null,inItemPrice: 0,remainingQuantity:null,oldRemainingQuantity:null,updateStorinItem:false,quantity:null,quantityShow:true})
                                }
                            });

                        }
                    });
                }else{
                    this.isDate();
                    return updateStorIn(params).then(data =>{
                        let {data:res={}}=data;
                        if(res.errcode===200){
                            this.$message({
                                showClose: true,
                                message: '修改成功！',
                                type: 'success'
                            });
                            this.cancelAdd();
                            if(this.typeId==2){
                                this.$router.push({
                                    name: '客戶詳情',
                                    params:{
                                        id:this.custId,
                                    }
                                })
                                this.$store.commit("closeTab", 'updateStockin');
                            }else{
                                this.$router.push({
                                    name: '入倉',
                                    params: {str: new Date().getTime()}
                                })
                                this.$store.commit("closeTab", 'updateStockin');
                            }
                        }else{
                            this.$message.error(res.errmsg);
                            this.submitInfo = true;
                        }
                    })

                }
            },
            RndNum(){//生成一個15位元數的數字
                let rnd="";
                for(let i=0;i<15;i++){
                    rnd+=Math.floor(Math.random()*10);
                }
                return rnd;
            },
            storInAdd(){/*顯示添加入庫資訊 關閉入庫資訊*/
                this.selLocationState();//查詢架子
                this.add = true;
                this.show = false;
                this.rkCont = true;
                this.nullList();
                this.form.createDate =new Date().Format("yyyy-MM-dd hh:mm");
                this.addWarehousingList[0].createDate=new Date().Format("yyyy-MM-dd hh:mm");
                //console.log(this.addWarehousingList);
            },
            cancelAdd(){/*顯示入庫資訊 關閉添加入庫資訊*/
                this.add = false;
                this.show = true;
                this.nullList();
                this.list=[];
            },
            addList(i,index,str){/*修改是否能輸入*/
                if(str==="cCode"){
                    this.addWarehousingList[i].storInItem[index].locationIdShows=false;
                    return
                }
                if(str==="unit") {
                    this.addWarehousingList[i].storInItem[index].itemShows = false;
                    return
                }
                if(str==="item"){
                    this.addWarehousingList[i].storInItem[index].ckgShow = false;
                    return
                }
                if(str==="remainingQuantity") {
                    let box = Number(this.addWarehousingList[i].storInItem.length)
                    const temp = this.addWarehousingList[i].storInItem[box - 1]
                    if(temp.locationId && temp.unit && temp.item && temp.remainingQuantity){
                        this.addWarehousingList[i].storInItem.push({state:0,unitShow:true,unit:'',num:1,addStorinItem:true,boxNo:box+1,item:'',qty:null,locationId:'',value:'',itemShows:true,qtyShow:true,locationIdShows:false,length:null,wide:null,high:null,volume:null,remainingVolume:null,oldRemainingVolume:null,countVolume:null,deliverGodown:null,deliverVolume:null,inItemPrice:0,remainingQuantity:null,oldRemainingQuantity:null,updateStorinItem:false,ckgShow:true,quantity:null,quantityShow:true});
                    }
                }
            },
            handleBlurVolume(item, i) {
                const value = item.remainingVolume
                let regex = /^[1-9]\d*$/
                let message = '請輸入大於0的整數'
                if(this.form.unitVolume=='3'){
                    regex = /(^(\d+)(\.\d{1,2})?$)/
                    message='请输入非零最多两位小数的数字'
                }else{
                    regex = /^[1-9]\d*$/
                    message = '請輸入大於0的整數'
                }
                if(value == 0 || !regex.test(value)){
                    if(value == '' || value == null){

                    }else this.$message({ type: 'warning', message})
                    item.volume = Number(item.deliverVolume || 0)
                    const a = Math.ceil(Number(this.form.price || 0) * item.volume * 100)
                    item.inItemPrice = a / 100
                    item.remainingVolume = null

                    // 總體積
                    let num = 0
                    this.addWarehousingList[i].storInItem.map((v)=>{
                        const temp = (Number(v.remainingVolume || 0)*100) + (Number(v.deliverVolume || 0)*100)
                        v.volume = temp / 100
                        num = Number(v.volume || 0) * 100 + num
                    })
                    this.form.totalVolume = num / 100

                    if(this.form.price){
                        const amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100)
                        this.form.totalPrice = amount / 100
                    }
                    this.$forceUpdate()
                    return
                }
                
                const a =  ((Number(item.deliverVolume || 0) * 100) + (Number(item.remainingVolume || 0) * 100))
                const b = a / 100
                const sum = Math.ceil(Number(this.form.price || 0) * b * 100)
                item.inItemPrice = sum / 100

                // 總體積
                let num = 0
                this.addWarehousingList[i].storInItem.map((v)=>{
                    const temp = (Number(v.remainingVolume || 0)*100) + (Number(v.deliverVolume || 0)*100)
                    v.volume = temp / 100
                    num = Number(v.volume || 0) * 100 + num
                })
                this.form.totalVolume = num / 100

                if(this.form.price){
                    const amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100)
                    this.form.totalPrice = amount / 100
                }
                this.$forceUpdate()
            },
            handleArea(field, item, i) {
                const value = item[field]
                const regex = /^[1-9]\d*$/
                if(value == 0 || !regex.test(value)) {
                    if(value == '' || value == null) {

                    } else this.$message({ type: 'warning', message: '請輸入大於0的整數' })
                    item[field] = null
                    item.volume = null
                    item.countVolume = null
                    item.inItemPrice = 0
                    // 總體積
                    let num = 0
                    this.addWarehousingList[i].storInItem.map((v)=>{
                        num = Number(v.volume || 0) * 100 + num
                    })
                    this.form.totalVolume = (num / 100 ).toFixed(2)

                    if(this.form.price){
                        const amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100)
                        this.form.totalPrice = amount / 100
                    }
                    this.$forceUpdate()
                    return
                }
                // volume 統計
                if(item.high && item.wide && item.length) {
                    const area = Math.ceil((item.length * item.wide  * item.high * 35.314) / 1000000) 
                    item.countVolume = area 
                    item.volume = area

                    const sum = Math.ceil(Number(this.form.price || 0) * item.volume * 100)
                    item.inItemPrice = sum / 100

                    item.quantityShow = false
                }
                // 總體積
                let num = 0
                this.addWarehousingList[i].storInItem.map((v)=>{
                    num = Number(v.volume || 0) * 100 + num
                })
                this.form.totalVolume = (num / 100 ).toFixed(2)

                if(this.form.price){
                    const amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100)
                    this.form.totalPrice = amount / 100
                }
                this.$forceUpdate()
            },
            handlePrice(val) {
                const value = val
                const regex = /(^(\d+)(\.\d{1,2})?$)/
                if(!regex.test(value)) {
                    if(value == '' || value == null) {

                    }else this.$message({ type: 'warning', message: '请输入非零最多两位小数的数字' })
                    this.form.price = null
                    this.form.totalPrice = null
                    this.addWarehousingList[0].storInItem.map((v)=>{
                        v.inItemPrice = 0
                    })
                    this.$forceUpdate()
                    return
                }

                this.addWarehousingList[0].storInItem.map((v)=>{
                    const sum = Math.ceil(Number(this.form.price || 0) * Number(v.volume || 0) * 100)
                    v.inItemPrice = sum / 100
                })
                if(this.form.totalVolume) {
                    const amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume || 0) * 100)
                    this.form.totalPrice = amount / 100
                }else{
                    this.form.totalPrice = null
                }
                this.$forceUpdate()
            },
            handleChangeUnit(val) {
                if(val!='3'){
                    let num = 0 // 总体积
                    this.addWarehousingList[0].storInItem.map((v)=>{
                        v.volume = Math.ceil(Number(v.remainingVolume || 0)) + Number(v.deliverVolume || 0)
                        v.inItemPrice = Number(this.form.price || 0) * Number(v.volume || 0)
                        num = Number(v.volume || 0) * 100 + num
                        num = Number(v.volume || 0) * 100 + num
                    })
                    this.form.totalVolume = num / 100

                    if(this.form.price){
                        const amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100)
                        this.form.totalPrice = amount / 100
                    }else{
                        this.form.totalPrice = null
                    }
                }
                $forceUpdate()
            },
            selCutomerCode(){/*查詢客戶編號*/
                return getCustomerCodeList().then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        this.customerCode =res.data;
                        this.customerCode.forEach((a,b)=>{
                            this.$set(this.customerCode[b],'value',a.code);//向陣列裡添加value欄位
                        });
                    }
                });
            },
            letSalesList(){/*查詢銷售員LIST*/
                return getSalesList().then(data=>{
                    let {data:res={}}=data;
                    //console.log(res)
                    if(res.errcode===200){
                        this.salesList = res.data;
                        this.salesList.forEach((a,b)=>{
                            this.$set(this.salesList[b],'value',a.name);//向陣列裡添加value欄位
                        });
                    }
                });
            },
            selLocationState(){/*查詢位置資訊*/
                return getLocationByState(Number(0)).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        this.locationList=res.data;
                        let sotrOnMap= new Map();
                        this.locationList.forEach((a,b)=>{
                            if(a.floor === "0"){
                                sotrOnMap.set(b,{id:a.id,location:"GF "+a.name});
                            }else {
                                sotrOnMap.set(b,{id:a.id,location:a.floor+"F "+a.name});
                            }
                        });
                        let list =[... sotrOnMap.values()];
                        this.list = list.map(item => {
                            return { value: item.id, label: item.location };
                        });
                        //console.log("resL",this.list);
                    }
                });
            },
            getLocationByCusId(id){/*以客戶ID查詢當前客戶在用的架子*/
                if(this.storInId !== 0){//入庫單ID为空 没有架子
                    return getCIdList({id:this.storInId,cusId:id}).then(data=>{
                        let {data:res={}}=data;
                        if(res.errcode===200){
                            this.locationList=res.data;
                            let sotrOnMap= new Map();
                            this.locationList.forEach((a,b)=>{
                                if(a.floor === "0"){
                                    sotrOnMap.set(b,{id:a.id,location:"GF "+a.name});
                                }else {
                                    sotrOnMap.set(b,{id:a.id,location:a.floor+"F "+a.name});
                                }
                            });
                            let list =[... sotrOnMap.values()];
                            let Tlist =list.map(item => {
                                return { value: item.id, label: item.location };
                            });
                            let this_ = this;
                            let t1 = setInterval(function () {//定时器 3秒后加载到list
                                for(var i=0; i< Tlist.length;i++){
                                    this_.list.unshift(Tlist[i])
                                }
                                clearTimeout(t1);
                            },3000);
                        }
                    });
                }
            },
            getRemarkList(){/*查詢常用列表*/
                return getAllRemarkList(1).then(data =>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        this.remarkList = res.data;
                        this.remarkList.forEach((a,b)=>{
                            this.$set(this.remarkList[b],'value',a.content);//向陣列裡添加value欄位
                        });
                    }
                });
            },
            nullList(){/*清空*/
                this.addWarehousingList =[
                    {state:1,second:1,createDate:null,code:null,addStorIn:true,storInItem:[{state:0,unitShow:true,unit:'',num:1,boxNo:1,item:'',qty:null,locationId:'',value:'',boxNoShow:true,itemShows:true,qtyShow:true,locationIdShows:true,length: null,wide:null,high:null,ckgShow:true,volume:null,remainingVolume:null,oldRemainingVolume:null,countVolume:null,deliverGodown:null,deliverVolume:null,inItemPrice:0,remainingQuantity:null,oldRemainingQuantity:null,updateStorinItem:false,quantity:null,quantityShow:true}]},
                ];
                this.form ={
                    id:null, code:null, name:null, phone:null, address:null, sales:null, createDate:null,sCode:''
                };
                this.updateStorIn="";
                this.storInId=0;
                //this.form.createDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
            },
            test(){
                this.show=true;
                this.add = false;
            },
            getStockInParams(){
                this.acctStockId = this.$route.params.id;
                this.selSotrIn(this.acctStockId,this.$route.params.typeId,this.$route.params.custId);
            },
        },
        activated(){/*進入載入*/
            getStaffAllList().then(data=>{
                let {data:res={}}=data;
                this.custSalesList=res.data;
            });
            this.cancelAdd();
            this.selCutomerCode();
            this.letSalesList();//查詢銷售員
            this.getRemarkList();//常用列表
            this.getStockInParams();
            Date.prototype.Format = function (fmt) {
                var o = {
                    "M+": this.getMonth() + 1, //月份
                    "d+": this.getDate(), //日
                    "h+": this.getHours(), //小時
                    "m+": this.getMinutes(), //分
                    "s+": this.getSeconds(), //秒
                    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                    "S": this.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                return fmt;
            };
        },
        computed:{

        },
        watch:{
            '$route':'test'
        },
    }
</script>
<style>
    .xinz button{background:#4B78FF;border:none;margin-bottom:1rem;}
    .xinz button:hover{background:#4B78FF;color:#fff;}
    .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{background-color:#aab5c5 }
    .el-form-item {
        margin-bottom: 5px;
    }
    table.responsive th, 
    table.responsive td {
        padding: 5px;
    }
    .el-dialog--center .el-dialog__body {
        padding: 0px 20px 30px !important;
    }
    .el-table th{
        background-color: #4B78FF !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/UpdateStockIn.vue